/**
 * The row element is used to group seats in rows.
 * Seats that are part of the same row can then be analysed more easily in the "singleSeat" scenario.
 * @class DataRow
 */
export default class DataRow {
  constructor (opts) {
    opts = opts || {};

    /**
     * This is the id for the section that this row is part of
     * @type {String}
     */
    this.section = opts.section;

    /**
     * This is the block in which this row is part of ("G-H2")
     * @type {String}
     */
    this.block = opts.block;

    /**
     * This is the code name for the row
     * @type {String} */
    this.name = opts.name;

    /**
     * This is the array of seats that are part this row.
     * Its an array of Seat objects
     * @type {Array<DataSeat>} */
    this.seats = opts.seats;

    /**
     * This should get the number of available seats in a section
     * @type {Number} */
    this.availableSeatCount = opts.availableSeatCount;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/schemas/Row.js